import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const TableSearchSessions = styled.form`
  display: flex;
  gap: 1rem;
  align-items: end;
  flex: 1;
`; 